import React, { Component } from 'react'
import { connect } from 'react-redux'
import identity from 'lodash.identity'
import { fetchResourceRequest } from '../../actionCreators/resource/resourceActionCreators'
import { project } from '../../utils'
import Carousel from './Carousel'
import { citrusBeaconReport } from './helpers/CarouselHelper'

class CarouselContainer extends Component {
  componentDidMount() {
    if (this.props.products.length > 0) {
      const { products, requestResource } = this.props

      const partNumberList = products.map(project.id)
      partNumberList.forEach(partNumber => requestResource({ partNumber }))
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.products.length !== prevProps.products.length) {
      const { products, requestResource } = this.props

      const partNumberList = products.map(project.id)
      partNumberList.forEach(partNumber => requestResource({ partNumber }))
    }

    // This code is just for Citrus Beacons Impressions
    if (this.props.alternativesInfoList[0]?.citrusId) {
      if (
        this.props.alternativesInfoList.length !== prevProps.alternativesInfoList.length ||
        this.props.alternativesInfoList[0]?.citrusId !== prevProps.alternativesInfoList[0]?.citrusId
      ) {
        const prevProductIds = prevProps.alternativesInfoList.map(project.citrusId)
        this.props.alternativesInfoList.forEach(product => {
          if (!prevProductIds.includes(product.citrusId)) {
            citrusBeaconReport(product.citrusId, 'first-i')
          }
        })
      }
    }
  }

  render() {
    return <Carousel {...this.props} />
  }
}

const getBadgeValues = (badgesPriorityOrdered, badges) =>
  badgesPriorityOrdered?.map(id => badges?.[id]?.attributes?.badgeReference) || []

const buildInfo = (data, meta) => originalProduct => {
  const partNumber = originalProduct.id

  const resource = data[partNumber]

  if (!resource || meta[partNumber].errorDetail || !meta[partNumber].requestDone) {
    return null
  }

  if (!resource?.prices) {
    return null
  }

  const { products, prices, reviewstatistics, badges, badgesPriority } = resource

  const badgeData = {
    BADGE_VALUE: getBadgeValues(badgesPriority?.BADGE_VALUE, badges),
    BADGE_PRODUCT: getBadgeValues(badgesPriority?.BADGE_PRODUCT, badges),
    BADGE_DELIVERY: getBadgeValues(badgesPriority?.BADGE_DELIVERY, badges)
  }

  const product = products[partNumber]

  const price = prices[partNumber]

  const reviewstatistic = reviewstatistics[partNumber]

  const id = partNumber

  const name = partNumber.startsWith('tuc')
    ? product.attributes.parentTitle || product.attributes.name
    : product.attributes.name

  const madeToOrder = product?.attributes?.madeToOrder
  const attributes = {
    price: price.attributes,
    name,
    reviewstatistics: reviewstatistic.attributes,
    badge: badgeData,
    madeToOrder
  }
  const alternativesInfo = { id, attributes, citrusId: originalProduct.ad_id }

  return alternativesInfo
}

const mapStateToProps = (state, ownProps) => {
  const { resource = {} } = state
  const { data = {}, meta = {} } = resource
  const { products, config, onPageLoad } = ownProps
  const alternativesInfoList = products.map(buildInfo(data, meta)).filter(identity)
  const props = { alternativesInfoList, config, onPageLoad }
  return props
}

const mapDispatchToProps = dispatch => {
  const requestResource = ({ partNumber }) => dispatch(fetchResourceRequest(partNumber))
  const props = { requestResource }
  return props
}

export default connect(mapStateToProps, mapDispatchToProps)(CarouselContainer)
export { CarouselContainer, mapStateToProps }
